<mat-card class="top-card mat-elevation-z0 no-padding overflowHidden">
  <div
    [class.collapsed]="isCollapsed"
    class="section-header padding d-flex overflowHidden clickable"
    (click)="toggleCollapsed()"
    [attr.aria-expanded]="!isCollapsed"
  >
    <div
      *ngIf="isWindowSticker() || isCustomWindowSticker()"
      class="projectTitle flexer"
    >
      Raamsticker
      {{
        inputProduct.type === 'WindowSticker'
          ? '(standaard afmetingen)'
          : '(op maat)'
      }}
      <span>#{{ index + 1 }}</span>
    </div>

    <div *ngIf="isBoard()" class="projectTitle flexer">
      Projectbord
      <span>#{{ index + 1 }}</span>
    </div>

    <div *ngIf="isOtherProduct()" class="projectTitle flexer">
      {{ getOtherProductLabel() }}
      <span>#{{ index + 1 }}</span>
    </div>

    <button
      *ngIf="!client"
      class="btn btn-sm pull-right"
      [disabled]="duplicateDisabled || disabled"
      (click)="copyProduct(); $event.stopPropagation()"
      mat-icon-button
    >
      <mat-icon svgIcon="duplicate"></mat-icon>
    </button>

    <button
      class="btn btn-sm pull-right"
      (click)="deleteProduct(); $event.stopPropagation()"
      [disabled]="disabled"
      mat-icon-button
    >
      <mat-icon svgIcon="close"></mat-icon>
    </button>

    <button
      mat-icon-button
      class="arrow-button pull-right"
      style="margin-top: 5px"
      [disabled]="disabled"
    >
      <mat-icon svgIcon="arrow-up"></mat-icon>
    </button>
  </div>

  <div [collapse]="isCollapsed" [isAnimated]="!safari">
    <ng-container *ngIf="renderChildren | async">
      <windowstickerForm
        *ngIf="isWindowSticker()"
        [inputProject]="inputProject"
        [inputProduct]="inputProduct"
        [involvedCompanies]="involvedCompanies"
        [pmsColorAdded]="pmsColorAdded"
        [standardStickerPartDeleted]="standardStickerPartDeleted"
        [client]="client"
        [fromOldSystem]="fromOldSystem"
        [disabled]="disabled"
        (outPutWindowSticker)="outputProduct.emit()"
      >
      </windowstickerForm>

      <custom-window-sticker
        *ngIf="isCustomWindowSticker()"
        [inputProject]="inputProject"
        [inputProduct]="inputProduct"
        [involvedCompanies]="involvedCompanies"
        [pmsColorAdded]="pmsColorAdded"
        [client]="client"
        [fromOldSystem]="fromOldSystem"
        [disabled]="disabled"
        (outPutWindowSticker)="outputProduct.emit()"
      >
      </custom-window-sticker>

      <board-form
        *ngIf="isBoard()"
        [inputProject]="inputProject"
        [inputProduct]="inputProduct"
        [involvedCompanies]="involvedCompanies"
        [pmsColorAdded]="pmsColorAdded"
        [client]="client"
        [fromOldSystem]="fromOldSystem"
        [disabled]="disabled"
        (outputBoard)="outputProduct.emit()"
      >
      </board-form>

      <other-product-form
        *ngIf="isOtherProduct()"
        [inputProject]="inputProject"
        [inputProduct]="inputProduct"
        [involvedCompanies]="involvedCompanies"
        [pmsColorAdded]="pmsColorAdded"
        [client]="client"
        [fromOldSystem]="fromOldSystem"
        [disabled]="disabled"
        (outputOtherProduct)="outputProduct.emit()"
      >
      </other-product-form>
    </ng-container>
  </div>
</mat-card>
